<mat-card class="profile-card">
  <mat-card-content>
    <p class="profile-card-info">
      <strong>Nombre completo:</strong> {{ profile.Name }}
    </p>
    <p class="profile-card-info">
      <strong>Tipo de identificación:</strong>
      {{ profile.MH_PersonType.Name_PersonType }}
    </p>
    <p class="profile-card-info">
      <strong>Identificación:</strong> {{ profile.ID_Number }}
    </p>
    <p class="profile-card-info-default" *ngIf="profile.Default && !showActions">
      Predeterminado
    </p>
  </mat-card-content>
  <mat-card-actions class="profile-card-actions" *ngIf="showActions">
    <button mat-icon-button>
      <mat-icon> {{ !!profile.Default ? "star" : "star_border" }}</mat-icon>
    </button>
    <button mat-icon-button (click)="eb()"><mat-icon>edit</mat-icon></button>
  </mat-card-actions>
</mat-card>
